import { useCallback, useMemo } from "react";

import { Stack } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellLink from "ds/components/Table/Row/CellLink";

import useStackListAnalytics from "../../useStackListAnalytics";
import useCellCopyAction from "../useCellCopyAction";
import { STACKS_COLUMN_ID } from "../constants";

const StacksTableNameCell = ({ item: stack, ...cellProps }: TableSimpleCellProps<Stack>) => {
  const trackAnalytics = useStackListAnalytics();

  const handlePress = useCallback(() => {
    trackAnalytics("Link clicked");
  }, [trackAnalytics]);

  const copyAction = useCellCopyAction({
    column: STACKS_COLUMN_ID.NAME,
    text: stack.name,
  });

  const actions = useMemo(() => [copyAction], [copyAction]);

  return (
    <TableSimpleCell {...cellProps} role="rowheader" actions={actions}>
      <TableCellLink href={`/stack/${stack.id}`} onPress={handlePress}>
        {stack.name}
      </TableCellLink>
    </TableSimpleCell>
  );
};

export default StacksTableNameCell;
